<script>
  import TextField from "../utils/TextField.svelte";
  import Textarea from "../utils/Textarea.svelte";
  import Dropdown from "../utils/Dropdown.svelte";
  import ImageIcon from "./ImageIcon.svelte";
  import Buttons from "./Buttons.svelte";
  import Action from "./Action.svelte";
  import { actions } from "../constants";
  import { notification, PHP, alert } from "../store.js";
  import { sendNotification } from "../api";
  import validate from "validate.js";
  import constraints from "./validators";
  import { normalizer } from "./normalizer";
  import { isEmpty, mergeAll, values, keys } from "ramda";
  import ActionModal from "../utils/ActionModal.svelte";
  import Preview from "./Preview.svelte";
  import to from "await-to-js";
  import Message from "../utils/Message.svelte";

  let error = {};
  let displayModal = false;
  let inprogress = false;

  const options = actions.map(i => i.option);

  // Check if notification object is inner values are empty of not
  const hasError = _allValues => {
    const allValues = values(_allValues);

    for (let i = 0; i < allValues.length; i++) {
      if (Array.isArray(allValues[i]) || typeof allValues[i] === "object") {
        return hasError(mergeAll(allValues[i]));
      } else if (!isEmpty(allValues[i]) && allValues[i] != undefined) {
        return true;
      }
    }

    return false;
  };

  const openConfirmModal = () => {
    error = validate($notification, constraints, {
      format: "svelte",
      fullMessages: false
    });
    
    if (hasError(error)) return;

    displayModal = true;
  };

  const closeConfirmModal = () => (displayModal = false);

  const sendTheNotification = async () => {
    inprogress = true;

    let [_, response] = await to(
      sendNotification(normalizer({ ...$notification, app_ids: [$PHP.app_id] }))
    );

    inprogress = false;

    if (response) {
      alert.setWithTimeout({value: 'Notification is successfully sent', className: 'is-success'});
      notification.reset();
    }
  };
</script>

<style>
  .uploader-wrapper {
    padding: 15px 10px;
    margin: 0 0 15px 0;
  }
  .buttons {
    margin-bottom: 0;
    padding: 20px 0 0 0;
  }
</style>

<div class="container is-fluid">
  <div class="notification">

    <Preview />

    <TextField
      title="Title"
      bind:value={$notification.title}
      error={error.title} />

    <Textarea
      title="Content"
      bind:value={$notification.content}
      error={error.content} />

    <Action
      title="Action"
      {options}
      bind:value={$notification.action.value}
      bind:url={$notification.action.url}
      defaultValue={options[1].value}
      error={(error || {}).action} />

    <Buttons error={(error || {}).buttons || {}} />

    <div class="uploader-wrapper">
      <div class="tile is-ancestor">
        <div class="tile">
          <ImageIcon
            type="icon"
            label="icon"
            bind:value={$notification.iconUrl} />
        </div>

        <div class="tile">
          <ImageIcon
            type="image"
            label={'image <span class="has-text-grey has-text-weight-light"> *notsupported by all browsers</span>'}
            bind:value={$notification.imageUrl} />
        </div>
      </div>
    </div>

    <p class="buttons">
      <span
        data-tooltip={!$PHP.isActivated ? 'You need to activate the plugin to send notifications' : undefined}>
        <button
          class="button"
          on:click={openConfirmModal}
          class:is-loading={inprogress}
          disabled={!$PHP.isActivated || inprogress}>
          Send Notification
        </button>
      </span>
    </p>

    <ActionModal
      show={displayModal}
      onDiscard={() => (displayModal = false)}
      onAccept={() => {
        sendTheNotification();
        closeConfirmModal();
      }}
      title="confirm sending"
      message="Are you sure you want to send the notification?" />
  </div>
</div>
